export default (state, action) => {
  switch (action.type) {
    case 'SET_STAGE':
      return {
        ...state,
        stage: action.stage,
      };

    case 'SET_LAST_COMPLETED':
      return {
        ...state,
        lastCompleted: action.lastCompleted,
      };

    case 'SET_TYPE':
      return {
        ...state,
        type: action.newType,
      };

    case 'SET_IS_LOADING':
      return {
        ...state,
        isLoading: action.isLoading,
      };

    case 'SET_NAME':
      return {
        ...state,
        name: action.name,
      };

    case 'SET_HEADLINE':
      return {
        ...state,
        headline: action.headline,
      };

    case 'SET_CTA_TEXT':
      return {
        ...state,
        ctaText: action.ctaText,
      };

    case 'SET_CTA_URL':
      return {
        ...state,
        ctaUrl: action.ctaUrl,
      };

    case 'SET_PRIMARY_COLOR':
      return {
        ...state,
        primaryColor: action.primaryColor,
      };

    case 'SET_SECONDARY_COLOR':
      return {
        ...state,
        secondaryColor: action.secondaryColor,
      };

    case 'SET_FILE_NAME':
      return {
        ...state,
        fileName: action.fileName,
      };

    case 'SET_FILE_URL':
      return {
        ...state,
        fileUrl: action.fileUrl,
      };

    case 'SET_PAGE':
      const pages = [
        ...state.pages
      ];

      if (action.page) {
        pages[action.i] = action.page;
      } else {
        pages.splice(action.i, 1);
      }

      return {
        ...state,
        pages,
      };

    case 'SET_UTM_SOURCE':
      return {
        ...state,
        utm_source: action.utm_source,
      };

    case 'SET_UTM_MEDIUM':
      return {
        ...state,
        utm_medium: action.utm_medium,
      };

    case 'SET_UTM_CAMPAIGN':
      return {
        ...state,
        utm_campaign: action.utm_campaign,
      };

    case 'SET_UTM_TERM':
      return {
        ...state,
        utm_term: action.utm_term,
      };

    case 'SET_UTM_CONTENT':
      return {
        ...state,
        utm_content: action.utm_content,
      };

    case 'SET_QUERY_PARAMETER':
      const queryParameters = [
        ...state.queryParameters
      ];

      if (action.queryParameter.key.length > 0 || action.queryParameter.value.length > 0) {
        queryParameters[action.i] = action.queryParameter;
      } else {
        queryParameters.splice(action.i, 1);
      }
      return {
        ...state,
        queryParameters,
      };

    case 'SET_CURRENT_SPOTLIGHT':
      if (!action.currentSpotlight.pages) {
        action.currentSpotlight.pages = [];
      }

      if (!action.currentSpotlight.queryParameters) {
        action.currentSpotlight.queryParameters = [];
      }

      return action.currentSpotlight;

    case 'CLEAR':
      return action.initialState;

    default:
      console.log("No case matched, returning existing state");
      console.log(state);
      return state;
  }
};
